import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const MESSAGES = {
  success: {
    EN: 'Successful Operation',
    AR: 'تمت العملية بنجاح',
  },
  failed: {
    EN: 'Failed Operation.. try again later',
    AR: 'فشلت العملية.. حاول مرة أخرى لاحقًا',
  },
};

function resolveLanguage(search) {
  const lang = (new URLSearchParams(search).get('lang') || '').toUpperCase();
  if (lang === 'EN' || lang === 'AR') return lang;
  return (navigator.language || 'en').toLowerCase().startsWith('ar') ? 'AR' : 'EN';
}

function Icon({ status }) {
  const color = status === 'success' ? '#2e9e44' : '#d93636';
  return (
    <svg width="88" height="88" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      {status === 'success'
        ? <path d="M7.5 12.5l3 3 6-6.5" />
        : <path d="M9 9l6 6M15 9l-6 6" />}
    </svg>
  );
}

export default function ResultPage({ status }) {
  const { search } = useLocation();
  const language = useMemo(() => resolveLanguage(search), [search]);

  return (
    <div
      dir={language === 'AR' ? 'rtl' : 'ltr'}
      style={{
        position: 'fixed',
        inset: 0,
        overflow: 'auto',
        background: '#fff',
        color: '#222',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
        padding: '24px',
        textAlign: 'center',
        fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <img alt="Kid Security" src="/kid-security-logo-en.avif" style={{ height: 40, maxWidth: '60%', objectFit: 'contain' }} />
      <Icon status={status} />
      <h3 style={{ margin: 0, fontSize: 22, fontWeight: 600 }}>{MESSAGES[status][language]}</h3>
    </div>
  );
}
